module.exports = __webpack_public_path__ + "static/img/police.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/police.png
// module id = g0FG
// module chunks = 57